<div class="mon-dialog-header">
  <h3 class="pt-6 mt-3 inline-block" translate>
    Get the Acquia Web Governance Extension
  </h3>
</div>
<div class="mon-dialog-body auto-scroll">
  <div class="pt-5 pb-3">
    <div class="text-center">
      <img [src]="currentExtension?.image" [attr.alt]="'Acquia Web Governance Extension' | translate" />
    </div>
    <div class="text-center mt-5">
      <a target="_blank" aria-describedby="linkOpensInNewTab"
         [href]="currentExtension?.url">
        {{ currentExtension?.downloadLabel }}
      </a>
    </div>
    <p
       class="pt-3 col-36 col-lg-24 m-auto float-none">
      Install the Acquia Web Governance {{ currentExtension?.label | translate:'':{extension: currentExtension?.label} }} and see QA, SEO and Accessibility issues right on your website.
      It's Visual Mode on Steroids (and it doesn't require our JS on your sites).
    </p>
  </div>
</div>
